import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCareCommentAnalysisDataList } from "./api";

export const ActionType = Object.freeze({
    base: "@@Monitoring/Action/Admin/CareCommentAnalysis",
    getList: "getList",
    dateSearch: "dateSearch"
});

export const getListAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getList}`,
    async (_, { rejectWithValue }) => {
        const response = await getCareCommentAnalysisDataList();

        if (response.error === undefined) {
            return { analysisDataList: response.analysisDataList };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const dateSearchAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.dateSearch}`,
    async (data: { registerDateStart: string, registerDateEnd: string }) => data
);
